/**
 * Mensaje legible desde respuestas de error de la API (FastAPI).
 */
export function formatApiError(err, fallback = 'Ocurrió un error') {
  const data = err?.response?.data;
  if (!data) return err?.message || fallback;
  const detail = data.detail ?? data.message;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (typeof d === 'string' ? d : d?.msg || JSON.stringify(d)))
      .join('\n');
  }
  if (detail && typeof detail === 'object') {
    return detail.msg || JSON.stringify(detail);
  }
  return fallback;
}
